<template>
  <v-row class="ma-0">
    <v-col v-if="!noheader" cols="12" class="pa-0">
      <v-toolbar flat height="60px" color="primary">
        <v-layout align-center>
          <v-btn icon dark small color="white" @click="onClose()" class="pa-0 ma-0">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title class="white--text pl-2">公開ユーザ管理</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-layout>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card tile flat class="px-2" :color="background">
        <v-row class="ma-0" align="center">
          <v-col v-if="noheader" cols="12" class="py-0 b-B-GREY-DARK" align="center">
            <v-row align="center" justify="center" style="height:48px;">
              <template v-for="(header, index) in headers">
                <v-col :cols="header.width" :align="header.align" class="pa-0" :key="header.key">
                  <template v-if="header.valid">
                    <v-sheet class="pa-0 customHeader" color="transparent">
                      <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                      <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                    </v-sheet>
                  </template>
                  <template v-else>
                    <span>{{ header.title }}</span>
                  </template>
                </v-col>
              </template>
              <v-col class="pa-0" align="center">
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0" align="center">
            <div class='overflow-y-auto'>
              <RecycleScroller
                class="scroller"
                :items="myUsers"
                :item-size="44"
                key-field="key"
              >
                <template v-slot="{ item }">
                  <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                    <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;">
                      <template v-for="(header) in headers">
                        <v-col :cols="header.width" class="pa-0" align="start" :key="header.key">
                          <template v-if="header.key == 'name'">
                            <v-row class="ma-0 pa-0" align="center">
                              <v-col cols="2" class="pa-0">
                                <v-avatar size="30">
                                  <img v-if="getAvatar(item)" :src='getAvatar(item)'>
                                  <v-avatar v-else size="30" color="primary"><span class="font-weight-bold white--text" style="font-size:20px; user-select: none;">{{ getNamePrefix(item) }}</span></v-avatar>
                                </v-avatar>
                              </v-col>
                              <v-col class="pa-0">
                                <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                              </v-col>
                            </v-row>
                          </template>
                          <template v-else-if="header.key == 'action'">
                            <v-btn x-small rounded depressed :color="checkStatus(item) ? 'error' : 'primary'" @click.stop="onRequest(item)">
                              <span>{{ checkStatus(item) ? '削除' : '登録' }}</span>
                            </v-btn>
                          </template>
                          <template v-else>
                            <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                          </template>
                        </v-col>
                      </template>
                    </v-row>
                  </v-sheet>
                </template>
              </RecycleScroller>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        :title="title"
        :message="requestMessage"
        :dialog='requestDialog'
        :color="requestColor"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      chatRef: 'chatRef/chatRef',
      chatRefStatus: 'chatRefStatus/chatRef',
      publicUsers: 'publicUsers/users'
    }),
    myUsers () {
      var temp = []
      if (this.group.chatsShare) {
        for (var i in this.publicUsers) {
          if (this.publicUsers[i].key !== this.user.uid) {
            temp.push(this.getViewData(JSON.parse(JSON.stringify(this.publicUsers[i]))))
          }
        }
      } else {
        for (i in this.users) {
          if (this.users[i].key !== this.user.uid) {
            temp.push(this.getViewData(JSON.parse(JSON.stringify(this.users[i]))))
          }
        }
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    }
  },
  data () {
    return {
      loading: false,
      requestDialog: false,
      title: null,
      requestMessage: null,
      requestColor: null,
      id: null,
      item: null,
      headers: [
        { valid: true, over: false, value: 2, title: '氏名', key: 'name', width: '6', align: 'start' },
        { valid: true, over: false, value: 0, title: '所属', key: 'schoolName', width: '5', align: 'start' },
        { valid: false, over: false, value: 0, title: '登録', key: 'action', width: '1', align: 'start' }
      ],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ]
    }
  },
  props: [ 'group', 'userref', 'noheader', 'background' ],
  methods: {
    getViewData (payload) {
      payload.publicType = payload.public ? '公開' : '非公開'
      payload.accessType = this.gerPrivileges(payload)
      // payload.createdDate = moment(payload.createdAt).format('YYYY-MM-DD')
      payload.enableType = payload.enable ? '有効' : '無効'
      payload.schoolName = this.getSchool(payload)
      return payload
    },
    gerPrivileges (user) {
      var index = this.$PRIVILEGES.findIndex(p => p.role === user.role)
      if (index !== -1) {
        return this.$PRIVILEGES[index].name
      }
      return ''
    },
    checkStatus (item) {
      var index = this.chatRefStatus.findIndex(c => c.key === this.userref.key)
      if (index !== -1) {
        return this.chatRefStatus[index].members[item.key]
      }
      return false
    },
    getSchool (item) {
      for (var key in item.schools) {
        if (item.schools[key]) {
          var index = this.schools.findIndex(school => school.key === key)
          if (index !== -1) {
            return this.schools[index].name
          }
        }
      }
      return ''
    },
    getAvatar (item) {
      var url = null
      if (item.avatar) {
        url = item.avatar.thumbnail
      }
      return url
    },
    getNamePrefix (item) {
      var name = '？'
      if (item.name) {
        name = item.name.slice(0, 1)
      }
      return name
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onRequest (item) {
      this.item = item
      this.title = '追加'
      if (this.checkStatus(item)) {
        this.requestMessage = item.name + ' さんを削除します。よろしいですか?'
        this.requestColor = 'error'
      } else {
        this.requestMessage = item.name + ' さんを招待します。よろしいですか?'
        this.requestColor = 'primary'
      }
      this.id = 'user'
      this.requestDialog = true
    },
    onDismissed: function (value) {
      if (this.requestDialog) {
        this.requestDialog = false
        if (value) {
          this.follow(this.item)
        }
      }
    },
    follow (item) {
      var vm = this
      var payload = null
      this.requestDialog = false
      this.$nextTick(function () {
        vm.loading = true
        if (vm.checkStatus(item)) {
          payload = {
            from: item.key,
            to: vm.userref,
            type: 'group',
            parameter: vm.userref
          }
          vm.$store.dispatch('chatRef/unfollow', payload).then(() => {
            vm.loading = false
          })
        } else {
          payload = {
            from: vm.userref,
            to: item,
            type: 'group',
            schools: vm.data.schools
          }
          vm.$store.dispatch('chatRef/followShareGroup', payload).then(() => {
            vm.loading = false
          })
        }
      })
    },
    onClose () {
      this.$emit('dismissed')
    }
  }
}
</script>

<style scoped>
.sheet-footer-text {
  cursor: pointer;
}

.v-card__text.memo{
  cursor: pointer;
}

.customHeader {
  cursor: pointer;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.v-icon {
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

.sheet-footer-text {
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

</style>
